import {IBizRaffle, IBusiness} from "@/views/editor/service/business";
import {AEditor} from "@/views/editor/service/editor";
import {EActivityStatus, IActivityBusinessMeta, IActivityNotifyCondition} from "@/model/activity";
import {ARaffle} from "@/views/editor/service/raffle/raffle";
import {CheckboxOptionType} from "ant-design-vue/es/checkbox/interface";
import {IPrizes, IRaffleRule} from "@/views/editor/service/types";
import {noPic} from "@/lib/util";

export interface IRaffleMeta {
    prizes: IPrizes[];
    chance_rules: IRaffleRule[]
    props: {
        mode: 'stock' | 'must' | 'normal'
        style: 'flop' | 'eggs' | 'game'
    }
}

export default class Raffle extends ARaffle implements IBizRaffle {
    readonly opt: IRaffleMeta

    constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
        this.opt = this.meta.setting as IRaffleMeta
    }

    subs(status: EActivityStatus): CheckboxOptionType[] {
        return {
            active: [],
            preheating: [],
            finished: []
        }[status]
    }

    resetMeta(): IBusiness {
        const opt: IRaffleMeta = {
            chance_rules: [
                {
                    "listen_event_id": "pms.activity.wechat.customer.sign",
                    "dependencies": ["activity", "activity"],
                    "target": "微信顾客",
                    "chance_count": 1
                }
            ], prizes: [
                {
                    cost_price_range: [],
                    front_value: 0,
                    gift_id: "",
                    image_url: noPic,
                    name: "噱头",
                    pdd_keyword: "",
                    percentage: 0,
                    stock: 0,
                    taobao_keyword: "",
                    thumb_url: ""
                }
            ], props: {mode: 'must', style: 'flop'}
        }
        Object.assign(this.opt, opt)
        return this;
    }

    setPrizes(owner: string, prizes: unknown[]): void {
        //
    }

    emptyRule(): IRaffleRule {
        return {
            listen_event_id: '',
            dependencies: [],
            target: '',
            chance_count: 1,
        }
    }

    emptyCondition(): IActivityNotifyCondition {
        return {relation: undefined as unknown as "∈" | "∉" | "=" | "≠", status: [], target: ""}
    }
}